import React, { useRef, useEffect } from 'react'
import { Card, Space } from 'antd'
import { useFFEStore } from '../../store/ffeStore'
import { EditableTitle } from '../Common/EditableTitle'
import { EditableTextArea } from '../Common/EditableTextArea'

export const ProjectDetails = () => {
  const projectTitle = useFFEStore((state) => state.document.projectTitle)
  const projectDescription = useFFEStore(
    (state) => state.document.projectDescription
  )
  const updateProjectTitle = useFFEStore((state) => state.updateProjectTitle)
  const updateProjectDescription = useFFEStore(
    (state) => state.updateProjectDescription
  )

  const [isEditing, setIsEditing] = React.useState(false)
  const editorRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        editorRef.current &&
        !editorRef.current.contains(event.target as Node)
      ) {
        setIsEditing(false)
      }
    }

    if (isEditing) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isEditing])

  return (
    <Card className="mb-6">
      <Space direction="vertical" className="w-full">
        <EditableTitle
          value={projectTitle}
          onChange={updateProjectTitle}
          placeholder="Enter Project Title"
          className="text-xl font-semibold"
        />

        <EditableTextArea
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          value={projectDescription}
          onChange={updateProjectDescription}
          placeholder="Click to add project description"
        />
      </Space>
    </Card>
  )
}
